"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.challengesGoals = void 0;
var env_1 = require("../../env");
exports.challengesGoals = {
  id: 'taxonomies',
  label: process.env.TAXONOMIES_LABEL || "Challenges & Goals",
  scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:taxonomies'] : null,
  children: [{
    id: 'challenges',
    type: 'list-expandable',
    entityTypeName: 'Challenge',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:challenges'] : null
  }, {
    id: 'keyIssues',
    type: 'list-expandable',
    entityTypeName: 'KeyIssue',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:key-issues'] : null
  }, {
    id: 'trends',
    type: 'list-expandable',
    entityTypeName: 'Trend',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:trends'] : null
  }, {
    id: 'topics',
    type: 'list-expandable',
    entityTypeName: 'Topic',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:topics'] : null
  }, {
    id: 'subTopics',
    type: 'list-expandable',
    entityTypeName: 'SubTopic',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:sub-topics'] : null
  }, {
    id: 'sdgs',
    type: 'list-expandable',
    entityTypeName: 'Sdg',
    scopes: env_1.USE_GRANULAR_SIDEBAR_SCOPES ? ['admin:any', 'read:menu:sdgs'] : null
  }]
};